$(document).ready(function () {
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * FancyBox
    // *
    // *
    $('[data-fancybox="modal"]').fancybox({
        smallBtn : false,
        toolbar  : false,
    });
    $('#modal .fancybox__close').click(function () {
        $.fancybox.close();
    });
    $('#modal .fancybox__close').bind( "touchstart", function(e){
        $.fancybox.close();
    } );



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *

    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.slick({
            fade: true,
            dots: true,
            arrows: false,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 5000,
            prevArrow: $(".js-hero-slider-nav-prev"),
            nextArrow: $(".js-hero-slider-nav-next"),
            responsive: []
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * TeamSlider
    // *
    // *
    // add id to every teamslider
    var cntteam = 1;
    $('.teamSlider .teamSlider__inner').each(function () {
        $(this).attr('id', function (index) {
            return "team" + cntteam;
        });
        cntteam++;
    });
    // adoptiveheight by 2 plus slides



    $('.teamSlider').each(function (index, sliderWrap) {
        var $slider = $(sliderWrap).find('.teamSlider__inner');
        var next = $(sliderWrap).find('.js-hero-slider-nav-next');
        var prev = $(sliderWrap).find('.js-hero-slider-nav-prev');

        $slider.slick({
            arrows: true,
            autoplay: false,
            speed: 1000,
            autoplaySpeed: 4000,
            slidesToShow: 2,
            slidesToScroll: 1,
            nextArrow: next,
            prevArrow: prev,
            infinite: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        autoplay: false,
                        adaptiveHeight: true,
                    }
                }
            ]
        });

    });



    // adoptiveheight by 2 plus slides
    if ($(window).width() > 767) {
        $('#team1').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var heights = [];
            $('#team1 .slick-active').each(function () {
                heights.push($(this).height());
            });
            $('#team1 .slick-list').height(Math.max.apply(null, heights));
        });
        $('#team1').on('init', function (event, slick) {
            var heights = [];
            $('#team1 .slick-active').each(function () {
                heights.push($(this).height());
            });
            $('#team1 .slick-list').height(Math.max.apply(null, heights));
        });
        $('#team2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var heights = [];
            $('#team2 .slick-active').each(function () {
                heights.push($(this).height());
            });
            $('#team2 .slick-list').height(Math.max.apply(null, heights));
        });
        $('#team3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var heights = [];
            $('#team3 .slick-active').each(function () {
                heights.push($(this).height());
            });
            $('#team4 .slick-list').height(Math.max.apply(null, heights));
        });
        $('#team4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var heights = [];
            $('#team4 .slick-active').each(function () {
                heights.push($(this).height());
            });
            $('#team4 .slick-list').height(Math.max.apply(null, heights));
        });
        $('#team5').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var heights = [];
            $('#team5 .slick-active').each(function () {
                heights.push($(this).height());
            });
            $('#team5 .slick-list').height(Math.max.apply(null, heights));
        });

    }
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll to top
    // *
    // *

    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.js-scrolltop').fadeIn();
        } else {
            $('.js-scrolltop').fadeOut();
        }
    });

    $('.js-scrolltop').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page

    $(".js-hero-scrolldown").click(function () {
        $('html, body').animate({
            scrollTop: $(this).offset().top
        }, 1000);
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Link in a new window
    // *
    // *

    $('a[rel*="external"]').click(function () {
        $(this).attr('target', '_blank');
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Hamburger
    // *
    // *

    $('.hamburger').click(function () {
        $(this).toggleClass('is-active');
        $('.mobilenav').toggleClass('mobilenav__open');
    });

    $('.mobilenav li a').click(function () {
        $('.hamburger').removeClass('is-active');
        $('.mobilenav').removeClass('mobilenav__open');
    });
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Change navigation by first scroll
    // *
    // *
    $(window).scroll(function () {
        if ($(window).scrollTop() >= 50) {
            $('.header').addClass('scroll');
            $('body').addClass('scroll');
        } else {
            $('.header').removeClass('scroll');
            $('body').removeClass('scroll');
        }
    });
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * desable scroll
    // *
    // *
    var disableScroll = false;
    var scrollPos = 0;
    function stopScroll() {
        disableScroll = true;
        scrollPos = $(window).scrollTop();
    }
    function enableScroll() {
        disableScroll = false;
    }
    $(function () {
        $(window).bind('scroll', function () {
            if (disableScroll) $(window).scrollTop(scrollPos);
        });
        $(window).bind('touchmove', function () {
            $(window).trigger('scroll');
        });
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Service Overlay
    // *
    // *

    $(".js-overlay").click(function () {
        var index = $(this).index();
        // $(this).parent().parent().find(".teaser__overlay").fadeIn();
        $(this).next(".services__overlay").show();
        $('html, body').animate({ scrollTop: $(this).closest(".services__item").offset().top - 100 }, 1000);
        return false;
    });
    $(".services__close").click(function () {
        $(this).closest(".services__overlay").hide();
        return false;
    });

    $('a').click(function () {
        var target = $(this.hash);
        if (target.length) {
            $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top - 110
            }, 1000);
            return false;
        }
    });
});
$(window).on('load', function () {
    if ($(window).width() > 767) {
        var heights1 = [];
        $('#team1 .slick-active').each(function () {
            heights1.push($(this).height());
        });
        $('#team1 .slick-list').height(Math.max.apply(null, heights1));

        var heights2 = [];
        $('#team2 .slick-active').each(function () {
            heights2.push($(this).height());
        });
        $('#team2 .slick-list').height(Math.max.apply(null, heights2));

        var heights3 = [];
        $('#team3 .slick-active').each(function () {
            heights3.push($(this).height());
        });
        $('#team3 .slick-list').height(Math.max.apply(null, heights3));

        var heights4 = [];
        $('#team4 .slick-active').each(function () {
            heights4.push($(this).height());
        });
        $('#team4 .slick-list').height(Math.max.apply(null, heights4));

        var heights5 = [];
        $('#team5 .slick-active').each(function () {
            heights5.push($(this).height());
        });
        $('#team5 .slick-list').height(Math.max.apply(null, heights5));
    }
});